<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">商户姓名：</span>
					<el-input v-model="search_name" class="b_inp" placeholder="商户姓名"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">商户手机号：</span>
					<el-input v-model="search_mobile" class="b_inp" placeholder="商户手机号"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">商户号：</span>
					<el-input v-model="search_number" class="b_inp" placeholder="商户号"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">区域：</span>
					<VDistpicker @province="handleSearchProvinceSelect" @city="handleSearchCitySelect" @area="handleSearchAreaSelect"></VDistpicker>
				</div>
				<div class="b_item">
					<span class="b_label">商务经理：</span>
					<el-select v-model="search_manager" filterable class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in appManager" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增商户</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="number"
						label="商户号"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="商户姓名"
					>
					</el-table-column>
					<el-table-column
						prop="mobile"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="sexText"
						label="性别"
					>
					</el-table-column>
					<el-table-column
						prop="managerName"
						label="商务经理"
					>
					</el-table-column>
					<el-table-column
						prop="managerMobile"
						label="商务经理手机号"
					>
					</el-table-column>
					<el-table-column
						prop="addr"
						label="省市区"
					>
					</el-table-column>
					<el-table-column
						prop="detailAddr"
						label="详细地址"
					>
					</el-table-column>
					<el-table-column
						prop="saleText"
						label="折扣"
					>
					</el-table-column>
					<el-table-column
						prop="date"
						label="注册时间"
					>
					</el-table-column>
					<el-table-column
						prop="consume"
						label="累计消费额"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="150"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增商户 -->
		<add 
			v-model="add_display" 
			@onSuccess="addSuccess"
		></add>
		<!-- 新增商户 end -->
		
		<!-- 修改商户 -->
		<update 
			v-model="update_display" 
			:obj="update_data"
			@onSuccess="updateSuccess"
		></update>
		<!-- 修改商户 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import Update from './components/update.vue';
	import { mapState } from 'vuex';
	import Api from '../../../../../../api/index.js';
	import BaseMethods from '../../../../../../assets/js/base.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				search_name: '',
				search_mobile: '',
				search_startDate: '',
				search_endDate: '',
				search_number: '',
				search_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				search_manager: '',
				tableData: [],
				total: 0,
				currentPage: 1,
				
				add_display: false,
				
				update_display: false,
				update_data: {}
			}
		},
		computed: {
			...mapState([
				'appManager'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 开始时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 结束时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 切换查询区域省份
			handleSearchProvinceSelect (data) {
				this.search_addr.provinceName = data.code ? data.value : '';
				this.search_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 切换查询区域城市
			handleSearchCitySelect (data) {
				this.search_addr.cityName = data.code ? data.value : '';
				this.search_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 切换查询区域区域
			handleSearchAreaSelect (data) {
				this.search_addr.areaName = data.code ? data.value : '';
				this.search_addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击新增商户
			handleAddClick() {
				this.add_display = true;
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getData();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			
			/******************** @Function *************************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					commUserName: that.search_name,
					userPhone: that.search_mobile,
					bUserId: that.search_manager,
					commCode: that.search_number,
					uAreaCode: that.search_addr.areaCode,
					start: that.search_startDate,
					end: that.search_endDate
				};
				Api.findAppMerchants(requestData).then((res) => {
					if (res.data.success) {
						let list = [];
						that.loading = false;
						that.total = res.data.data.total;
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								number: v.commCode,
								name: v.commUserName,
								mobile: v.userPhone,
								sex: v.userSex,
								sexText: BaseMethods.mapSexToText(v.userSex),
								managerId: v.bUserId,
								managerName: v.buserName,
								managerMobile: v.uPhone,
								provinceName: v.uprovinceName,
								provinceCode: v.uProvinceCode,
								cityName: v.ucityName,
								cityCode: v.uCityCode,
								areaName: v.uareaName,
								areaCode: v.uAreaCode,
								lng: v.longitude || '',
								lat: v.latitude || '',
								addr: `${ v.uprovinceName }${ v.ucityName }${ v.uareaName }`,
								detailAddr: v.locationDetail,
								sale: v.commPercent,
								saleText: `${ v.commPercent }%`,
								date: BaseMethods.formatTime(v.createTs),
								consume: v.totalMoney
							});
						});
						that.tableData = list;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增成功
			addSuccess() {
				this.getData();
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			}
		},
		components: {
			Add,
			Update
		}
	}
</script>

<style scoped>
</style>
